import thunk from 'redux-thunk';
import { createStore } from 'redux';

import reducer from './root_reducer';
import { applyMiddleware } from 'helpers/redux_dev_tools';

export default function(state) {
  const store = createStore(reducer, state, applyMiddleware(thunk));

  if (module.hot) {
    module.hot.accept('./root_reducer', () => {
      store.replaceReducer(require('./root_reducer'));
    });
  }

  return store;
}
